
<script>
export default {
  name: 'NodeItem',
  functional: true,
  props: {
    node: {
      type: Object,
      default: () => {}
    }
  },
  render: function(h, context) {
    const { node } = context.props
    return node
  }
}
</script>
